<template>
	<div>
		<Card>
			<b-row align-v="center" slot="header">
				<b-col cols="8">
					<h3 class="mb-0">Event Information</h3>
				</b-col>
				<b-col cols="4" class="text-right">
					<BaseButton
						:disabled="!isUpdatingProfile"
						size="sm"
						@click="showQuestionModal = true"
						>Update Event</BaseButton
					>
				</b-col>
			</b-row>
			<form>
				<base-input
					label="Event Title"
					id="event title"
					placeholder="Event Title"
					required
					v-model="eventTitle"
				/>

				<base-input
					label="Event Id"
					id="event id"
					placeholder="Event Id"
					disabled
					v-model="eventData.eventId"
				/>

				<base-input label="Event Description">
					<textarea
						placeholder="Enter your description..."
						v-model="eventDescription"
						class="form-control"
						id="event description"
						rows="4"
						required
					></textarea>
				</base-input>

				<b-row>
					<b-col>
						<base-input
							required
							label="Event Start Time"
							type="datetime-local"
							v-model="eventStart"
							id="event start"
						/>
					</b-col>
					<b-col>
						<base-input
							label="Event End Time"
							type="datetime-local"
							v-model="eventEnd"
							id="event end"
						/>
					</b-col>
				</b-row>

				<b-row>
					<b-col>
						<base-input
							v-model="eventLocation"
							label="Event Location"
							placeholder="Event Location"
							id="event location"
						/>
					</b-col>
				</b-row>

				<b-row>
					<b-col>
						<base-input
							label="Category"
							id="category"
							type="multiselect"
							:internalSearch="false"
							@remove="onCategoryRemoved"
							@select="onCategorySelected"
							:multiSelectOptions="categoryOptions"
							:multiSelectValue="eventCategory"
						/>
					</b-col>
				</b-row>

				<base-input placeholder="Select A Speaker" label="Speaker #1">
					<select
						class="form-control"
						id="eventFacultyLeader"
						v-model="eventSpeaker1"
					>
						<option
							v-for="leader in allSpeakers"
							:key="leader.speakerId"
							:value="leader.speakerId"
							:selected="leader.speakerId == eventSpeaker1"
						>
							{{ leader.speakerName }}
						</option>
					</select>
				</base-input>
				<base-input placeholder="Select A Speaker" label="Speaker #2">
					<select
						class="form-control"
						id="eventFacultyLeader"
						v-model="eventSpeaker2"
					>
						<option
							v-for="leader in allSpeakers"
							:key="leader.speakerId"
							:value="leader.speakerId"
							:selected="leader.speakerId == eventSpeaker2"
						>
							{{ leader.speakerName }}
						</option>
					</select>
				</base-input>
				<base-input placeholder="Select A Speaker" label="Speaker #3">
					<select
						class="form-control"
						id="eventFacultyLeader"
						v-model="eventSpeaker3"
					>
						<option
							v-for="leader in allSpeakers"
							:key="leader.speakerId"
							:value="leader.speakerId"
							:selected="leader.speakerId == eventSpeaker3"
						>
							{{ leader.speakerName }}
						</option>
					</select>
				</base-input>
				<base-input placeholder="Select A Speaker" label="Speaker #4">
					<select
						class="form-control"
						id="eventFacultyLeader"
						v-model="eventSpeaker4"
					>
						<option
							v-for="leader in allSpeakers"
							:key="leader.speakerId"
							:value="leader.speakerId"
							:selected="leader.speakerId == eventSpeaker4"
						>
							{{ leader.speakerName }}
						</option>
					</select>
				</base-input>
				<base-input placeholder="Select A Speaker" label="Speaker #5">
					<select
						class="form-control"
						id="eventFacultyLeader"
						v-model="eventSpeaker5"
					>
						<option
							v-for="leader in allSpeakers"
							:key="leader.speakerId"
							:value="leader.speakerId"
							:selected="leader.speakerId == eventSpeaker5"
						>
							{{ leader.speakerName }}
						</option>
					</select>
				</base-input>
				<base-input placeholder="Select A Speaker" label="Speaker #6">
					<select
						class="form-control"
						id="eventFacultyLeader"
						v-model="eventSpeaker6"
					>
						<option
							v-for="leader in allSpeakers"
							:key="leader.speakerId"
							:value="leader.speakerId"
							:selected="leader.speakerId == eventSpeaker6"
						>
							{{ leader.speakerName }}
						</option>
					</select>
				</base-input>
				<ButtonRadioGroup
						v-if="dataSets && dataSets.length > 0"
						label="Event"
						:options="dataSets"
						v-model="eventDataSet"
					></ButtonRadioGroup>
				<!-- Legacy primary/secondary schedule split. Hidden when the org has
				     multiple Events; the Event selector above replaces it. The
				     existing value is still saved unchanged. -->
				<ButtonRadioGroup
						v-if="eventTypes.length > 0 && !(dataSets && dataSets.length > 1)"
						label="Schedule Tab"
						:options="eventTypes"
						v-model="eventType"
					></ButtonRadioGroup>
			</form>
		</Card>
		<QuestionModal
			:show="showQuestionModal"
			:question="modalQuestion"
			@close="showQuestionModal = false"
			@yesClicked="updateEvent"
		/>
	</div>
</template>
<script>
import Card from '../../../components/Cards/Card.vue';
import BaseButton from '../../../components/BaseButton.vue';
import CurrencyInput from '../../../components/Inputs/CurrencyInput.vue';
import BaseSwitch from '../../../components/BaseSwitch.vue';
import moment from 'moment';
import { zonedTimeToUtc, utcToZonedTime, format as formatTz } from 'date-fns-tz';
import QuestionModal from '../../../components/Modals/QuestionModal.vue';
import { getOrganizationFirestore } from '../../../resources/organizationFirebase';
import { mapActions, mapGetters } from 'vuex';
import { arrayUnion, doc, setDoc, getDoc, deleteField } from '@firebase/firestore';
import ButtonRadioGroup from '../../../components/ButtonRadioGroup.vue';
import CategoryItemManager from '../../../models/CategoryItemManager';
import { buildDataSetHelper } from '../../../models/AnalyticsReports';

export default {
	computed: {
		...mapGetters({
			organization: 'getOrganization',
			dataSets: 'getDataSets',
		}),
	},
	props: {
		eventData: null,
		allSpeakers: [],
	},
	components: {
		Card,
		BaseButton,
		CurrencyInput,
		BaseSwitch,
		QuestionModal,
		ButtonRadioGroup
	},
	data() {
		return {
			isUpdatingProfile: false,
			showQuestionModal: false,
			modalQuestion: "Are you sure you want to update this event's information?",
			eventTitle: null,
			eventDescription: null,
			eventStart: null,
			eventEnd: null,
			eventLocation: null,
			eventCategory: null,
			categoryOptions: [],
			eventSpeaker1: null,
			eventSpeaker2: null,
			eventSpeaker3: null,
			eventSpeaker4: null,
			eventSpeaker5: null,
			eventSpeaker6: null,
			eventType: null,
			eventTypes: [],
			eventDataSet: null,
		};
	},
	watch: {
		eventTitle(val) {
			if (this.$helpers.isBlank(val)) {
				this.eventTitle = this.eventData.eventTitle;
			}
			this.isUpdatingProfile = this.checkIfUpdateNeeded();
		},
		eventDescription(val) {
			if (this.$helpers.isBlank(val)) {
				this.eventDescription = this.eventData.eventDescription;
			}
			this.isUpdatingProfile = this.checkIfUpdateNeeded();
		},
		eventStart(val) {
			this.isUpdatingProfile = this.checkIfUpdateNeeded();
		},
		eventEnd(val) {
			this.isUpdatingProfile = this.checkIfUpdateNeeded();
		},
		eventLocation(val) {
			if (this.$helpers.isBlank(val)) {
				this.eventLocation = this.eventData.eventLocation;
			}
			this.isUpdatingProfile = this.checkIfUpdateNeeded();
		},
		eventCategory(val) {
			this.isUpdatingProfile = this.checkIfUpdateNeeded();
		},
		eventSpeaker1(val) {
			this.isUpdatingProfile = this.checkIfUpdateNeeded();
		},
		eventSpeaker2(val) {
			this.isUpdatingProfile = this.checkIfUpdateNeeded();
		},
		eventSpeaker3(val) {
			this.isUpdatingProfile = this.checkIfUpdateNeeded();
		},
		eventSpeaker4(val) {
			this.isUpdatingProfile = this.checkIfUpdateNeeded();
		},
		eventSpeaker5(val) {
			this.isUpdatingProfile = this.checkIfUpdateNeeded();
		},
		eventSpeaker6(val) {
			this.isUpdatingProfile = this.checkIfUpdateNeeded();
		},
		eventType(val){
			this.isUpdatingProfile = this.checkIfUpdateNeeded();
		},
		eventDataSet(val){
			this.isUpdatingProfile = this.checkIfUpdateNeeded();
		}
	},
	methods: {
		...mapActions(['showNotification']),
		getEventTypes(){
			this.eventTypes = [];
			const firestore = getOrganizationFirestore(this.organization);
			const databaseRef = doc(firestore, 'account/publicInformation');
			getDoc(databaseRef).then((snapshot) => {
				if (snapshot.exists){
					const publicInformation = snapshot.data()
					if (publicInformation.appTitles){
						const appTitles = publicInformation.appTitles
						const titles = appTitles.filter((e) => e.type == 'schedulePrimary' || e.type == 'scheduleSecondary')
						if (titles){
							titles.forEach((e) => {
								this.eventTypes.push({
									value: e.type == 'schedulePrimary' ? 'primary' : 'secondary',
									name: e.title
								})
							})
						}
						
					}
				}
			})
		},
		resetView() {
			this.eventStart = this.setEventStart();
			this.eventEnd = this.setEventEnd();
			this.setFacultyLeader();
			this.eventTitle = this.eventData.eventTitle;
			this.eventDescription = this.eventData.eventDescription;
			this.eventLocation = this.eventData.eventLocation;
			this.eventType = this.setEventType();
			this.eventDataSet = this.setEventDataSet();
			if (this.eventData.eventCategoryId){
				this.eventCategory = this.categoryOptions.find((e) => e.categoryId == this.eventData.eventCategoryId)
			}
		},
		checkIfUpdateNeeded() {
			if (
				this.eventTitle != this.eventData.eventTitle ||
				this.eventDescription != this.eventData.eventDescription ||
				this.eventLocation != this.eventData.eventLocation
			) {
				return true;
			} else if (this.eventStart != this.setEventStart()) {
				return true;
			} else if (this.eventEnd != this.setEventEnd()) {
				return true;
			} else if (this.eventType != this.setEventType()){
				return true;
			} else if (this.eventDataSet != this.setEventDataSet()){
				return true;
			} else if (this.eventCategory){
				if (this.eventCategory.categoryId != this.eventData.eventCategoryId){
					return true;
				} 
			} else if (!this.eventCategory){
				if (this.eventData.eventCategoryId){
					return true;
				}
			} else if (this.eventData.eventSpeaker) {
				if (
					this.eventSpeaker1 != this.eventData.eventSpeaker[0] ||
					this.eventSpeaker2 != this.eventData.eventSpeaker[1] ||
					this.eventSpeaker3 != this.eventData.eventSpeaker[2] ||
					this.eventSpeaker4 != this.eventData.eventSpeaker[3] ||
					this.eventSpeaker5 != this.eventData.eventSpeaker[4] ||
					this.eventSpeaker6 != this.eventData.eventSpeaker[5]
				) {
					return true;
				}
			} else {
				return true;
			}
			return false;
		},
		setEventStart() {
			// Pre-fill using the America/New_York reading of the stored instant (matching how
			// the app always displays it), not the editing browser's own local zone — otherwise
			// re-saving without touching the time field would silently shift the event.
			var checkDate = this.eventData.eventStart.toDate();
			var zoned = utcToZonedTime(checkDate, 'America/New_York');
			return formatTz(zoned, "yyyy-MM-dd'T'HH:mm", { timeZone: 'America/New_York' });
		},
		setEventEnd() {
			if (this.eventData.eventEnd != null) {
				var checkDate = this.eventData.eventEnd.toDate();
				var zoned = utcToZonedTime(checkDate, 'America/New_York');
				return formatTz(zoned, "yyyy-MM-dd'T'HH:mm", { timeZone: 'America/New_York' });
			} else {
				return null;
			}
		},
		setFacultyLeader() {
			if (this.eventData.eventSpeaker) {
				this.eventSpeaker1 = this.eventData.eventSpeaker[0];
				this.eventSpeaker2 = this.eventData.eventSpeaker[1];
				this.eventSpeaker3 = this.eventData.eventSpeaker[2];
				this.eventSpeaker4 = this.eventData.eventSpeaker[3];
				this.eventSpeaker5 = this.eventData.eventSpeaker[4];
				this.eventSpeaker6 = this.eventData.eventSpeaker[5];
			}
		},
		setEventType(){
			return this.eventData.eventType ? this.eventData.eventType : 'primary'
		},
		setEventDataSet(){
			// Events with no dataSet field fall into the default dataSet bucket
			// (apps query `in [defaultId, null]`), so pre-select the default.
			if (!this.dataSets || this.dataSets.length == 0){
				return null
			}
			return this.eventData.dataSet ? this.eventData.dataSet : buildDataSetHelper(this.dataSets).defaultId
		},
		onCategoryRemoved() {
			this.eventCategory = null;
		},
		onCategorySelected(categoryData) {
			this.eventCategory = categoryData
		},
		updateEvent() {
			const firestore = getOrganizationFirestore(this.organization);
			const eventRef = doc(firestore, `events/${this.eventData.eventId}`);

			var updateInfo = {};

			updateInfo['eventStart'] = zonedTimeToUtc(this.eventStart, 'America/New_York');

			if (this.eventEnd != null) {
				updateInfo['eventEnd'] = zonedTimeToUtc(this.eventEnd, 'America/New_York');
			}

			if (this.eventTitle != this.eventData.eventTitle) {
				updateInfo['eventTitle'] = this.eventTitle;
			}

			if (this.eventDescription != this.eventData.eventDescription) {
				updateInfo['eventDescription'] = this.eventDescription;
			}

			if (this.eventLocation != this.eventData.eventLocation) {
				updateInfo['eventLocation'] = this.eventLocation;
			}

			if (this.eventCategory){
				if (this.eventCategory.categoryId != this.eventData.categoryId){
					updateInfo['eventCategoryId'] = this.eventCategory.categoryId
				}
			} else {
				updateInfo['eventCategoryId'] = deleteField();
			}

			if (this.eventType != this.setEventType()){
				updateInfo['eventType'] = this.eventType;
			}

			if (this.eventDataSet && this.eventDataSet != this.setEventDataSet()){
				updateInfo['dataSet'] = this.eventDataSet;
			}

			const eventSpeaker = [];

			if (this.eventData.eventSpeaker) {
				if (this.eventSpeaker1 != this.eventData.eventSpeaker[0]) {
					eventSpeaker.push(this.eventSpeaker1);
					updateInfo['eventSpeaker'] = eventSpeaker;
				}

				if (this.eventSpeaker2 != this.eventData.eventSpeaker[1]) {
					eventSpeaker.push(this.eventSpeaker1);
					eventSpeaker.push(this.eventSpeaker2);
					updateInfo['eventSpeaker'] = eventSpeaker;
				}

				if (this.eventSpeaker3 != this.eventData.eventSpeaker[2]) {
					eventSpeaker.push(this.eventSpeaker1);
					eventSpeaker.push(this.eventSpeaker2);
					eventSpeaker.push(this.eventSpeaker3);
					updateInfo['eventSpeaker'] = eventSpeaker;
				}

				if (this.eventSpeaker4 != this.eventData.eventSpeaker[3]) {
					eventSpeaker.push(this.eventSpeaker1);
					eventSpeaker.push(this.eventSpeaker2);
					eventSpeaker.push(this.eventSpeaker3);
					eventSpeaker.push(this.eventSpeaker4);
					updateInfo['eventSpeaker'] = eventSpeaker;
				}

				if (this.eventSpeaker5 != this.eventData.eventSpeaker[4]) {
					eventSpeaker.push(this.eventSpeaker1);
					eventSpeaker.push(this.eventSpeaker2);
					eventSpeaker.push(this.eventSpeaker3);
					eventSpeaker.push(this.eventSpeaker4);
					eventSpeaker.push(this.eventSpeaker5);
					updateInfo['eventSpeaker'] = eventSpeaker;
				}

				if (this.eventSpeaker6 != this.eventData.eventSpeaker[5]) {
					eventSpeaker.push(this.eventSpeaker1);
					eventSpeaker.push(this.eventSpeaker2);
					eventSpeaker.push(this.eventSpeaker3);
					eventSpeaker.push(this.eventSpeaker4);
					eventSpeaker.push(this.eventSpeaker5);
					eventSpeaker.push(this.eventSpeaker6);
					updateInfo['eventSpeaker'] = eventSpeaker;
				}
			} else {
				if (this.eventSpeaker1) {
					eventSpeaker.push(this.eventSpeaker1);
					updateInfo['eventSpeaker'] = eventSpeaker;
				}
				if (this.eventSpeaker2) {
					eventSpeaker.push(this.eventSpeaker2);
					updateInfo['eventSpeaker'] = eventSpeaker;
				}
				if (this.eventSpeaker3) {
					eventSpeaker.push(this.eventSpeaker3);
					updateInfo['eventSpeaker'] = eventSpeaker;
				}
				if (this.eventSpeaker4) {
					eventSpeaker.push(this.eventSpeaker4);
					updateInfo['eventSpeaker'] = eventSpeaker;
				}
				if (this.eventSpeaker5) {
					eventSpeaker.push(this.eventSpeaker5);
					updateInfo['eventSpeaker'] = eventSpeaker;
				}
				if (this.eventSpeaker6) {
					eventSpeaker.push(this.eventSpeaker6);
					updateInfo['eventSpeaker'] = eventSpeaker;
				}
			}

			setDoc(eventRef, updateInfo, { merge: true })
				.then(() => {
					this.updateData();
					this.showNotification({
						type: 'success',
						message: 'Event Updated.',
					});
				})
				.catch((error) => {
					this.showNotification({
						type: 'danger',
						message: `${error.message}`,
					});
				});
		},
		updateData() {
			this.eventData.eventTitle = this.eventTitle;
			this.eventData.eventDescription = this.eventDescription;
			this.eventData.eventLocation = this.eventLocation;
			this.eventData.eventCategoryId = this.eventCategory ? this.eventCategory.categoryId : null
			if (this.eventDataSet){
				this.eventData.dataSet = this.eventDataSet;
			}
			this.$emit('updateEvent', this.eventData);
		},
	},
	mounted() {
		this.categoryOptions = CategoryItemManager.allCategories.filter((category) => category.isSchedule == true);
		this.resetView();
		this.getEventTypes();
		//this.allSpeakers.unshift(null);
	},
};
</script>
